import 'containers/common/Detail.css';
import PropertyClassificationList from "containers/property/PropertyClassificationList";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";





export default class PropertyClassificationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true
        };
    }
    

    async componentDidMount() {
        console.log("In PropertyClassificationModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }

    

    

    renderPropertyClassifications() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.togglePropertyClassificationModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Property Classifications</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
               
                

              

                        <PropertyClassificationList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        classificationOptions={this.props.classificationOptions}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="PropertyClassificationEdit">
                {this.props.isAuthenticated ? this.renderPropertyClassifications() : console.log("error)")}
            </div>
        );
    }
}
